<h2 class="step-title">{{ zipTitle }}</h2>
@if (notDebtSettlement) {
  <p class="step-subtitle">{{ isReverseFlow ? 'No credit check to connect with lenders.' : 'Get rates with no credit check required!' }}</p>
}
@if (useUpdatedInputs) {
  @if (showAddressInput) {
    <p class="is-size-7 assurance">{{subtext}}</p>
  }
  @if (showAddressInput && isFullFastFlow) {
    <p class="is-size-7 assurance">Your address lets us match you with lenders licensed where you live and pull accurate local rates. It is secure and never sold.</p>
  }

  <div class="field address-field">
    <div class="address-input-group"
      [ngClass]="{
        'has-address': showAddressInput,
        'has-error': highlightingBoxForRequiredInfo && (zipErrorShown || streetErrorShown)
      }">
      <div class="control address-input-row">
        <input inputmode="numeric" class="input is-large address-input address-input-zip" type="text" aria-label="ZIP code" [attr.placeholder]="zipOfferShown ? offeredZip : 'Zip Code'" [attr.aria-describedby]="zipOfferShown ? 'zip-offer-hint' : null" maxlength="5" formControlName="zipCode"
        [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && zipErrorShown}"
        #zipCode (change)="zipChange($event)" name="zipCode" (input)="zipInput($event)" autocomplete="postal-code" autofillSync digitOnly>
      </div>

      @if (showAddressInput) {
        <div class="address-divider" aria-hidden="true"></div>
      }

      @if (showAddressInput) {
        <div class="control address-input-row">
          <input class="input is-large address-input address-input-street" type="text" placeholder="Street Address"
          [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && streetErrorShown}"
          formControlName="streetAddress" #streetAddress (change)="snap()" name="streetAddress" autocomplete="address-line1" autofillSync>
        </div>
      }
    </div>

    <!-- FRU-25232: always on the page, so a screen reader announces the text when an offer arrives after the box has focus -->
    <p id="zip-offer-hint" class="is-size-7 assurance zip-offer-hint" [class.is-empty]="!zipOfferShown" aria-live="polite">{{ zipOfferShown ? zipOfferHint : '' }}</p>

    @if (zipErrorShown) {
      <p class="help is-danger">Please enter a valid 5 digit US zip code.</p>
    }
    @if (showAddressInput && streetErrorShown) {
      <p class="help is-danger">Please fill out your valid street address.</p>
    }
  </div>
} @else {
  <div class="field">
    <div [ngClass]="{'control': true}">
      <input inputmode="numeric" class="input is-large border" type="text" aria-label="ZIP code" [attr.placeholder]="zipOfferShown ? offeredZip : 'Zip Code'" [attr.aria-describedby]="zipOfferShown ? 'zip-offer-hint' : null" maxlength="5" formControlName="zipCode"
      [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && zipErrorShown}"
      #zipCode (change)="zipChange($event)" name="zipCode" (input)="zipInput($event)" autocomplete="postal-code" autofillSync digitOnly>
    </div>

    <!-- FRU-25232: always on the page, so a screen reader announces the text when an offer arrives after the box has focus -->
    <p id="zip-offer-hint" class="is-size-7 assurance zip-offer-hint" [class.is-empty]="!zipOfferShown" aria-live="polite">{{ zipOfferShown ? zipOfferHint : '' }}</p>

    @if (zipErrorShown) {
      <p class="help is-danger">Please enter a valid 5 digit US zip code.</p>
    }
  </div>

  @if (showAddressInput) {
    <h2 class="step-title">{{ streetTitle }}</h2>
    <p class="is-size-7 assurance">{{subtext}}</p>
    @if (isFullFastFlow) {
      <p class="is-size-7 assurance">Your address lets us match you with lenders licensed where you live and pull accurate local rates. It is secure and never sold.</p>
    }

    <div class="field">
      <div [ngClass]="{'control': true}">
        <input class="input is-large" type="text" placeholder="Street Address"
        [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && streetErrorShown}"
        formControlName="streetAddress" #streetAddress (change)="snap()" name="streetAddress" autocomplete="address-line1" autofillSync>
      </div>

      @if (streetErrorShown) {
        <p class="help is-danger">Please fill out your valid street address.</p>
      }
    </div>
  }
}

<button class="button continue is-large has-shadow-small" (click)="submit()">
  Continue
  <i class="fas fa-chevron-right"></i>
</button>
